"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var permission_container_1 = require("./permission-container");
var roles_container_1 = require("./roles-container");
var user_roles_container_1 = require("./user-roles-container");
exports.resolve = function (permissionName, userId, context) {
    var userRolesRepo = new user_roles_container_1.UserRolesContainer();
    var roles = userRolesRepo.getRolesForUser(userId);
    if (!roles) {
        return false;
    }
    // see if the permission exists in a context-free form
    var contextFreePermission = roles.contextFree.permissions.find(function (permission) { return permission.name === permissionName; });
    if (contextFreePermission) {
        return true;
    }
    // see if the permission exists in a context-bound form
    var contextBoundPermission = roles.contextBound.permissions.find(function (permission) { return permission.name === permissionName; });
    if (contextBoundPermission) {
        var boundContext = contextBoundPermission.contexts.find(function (ctx) { return ctx.id === context.id && ctx.type === context.type; });
        if (boundContext) {
            return true;
        }
    }
    // we did not find the permission in neither form
    return false;
};
exports.initializeResolver = function (_a) {
    var permissions = _a.permissions, roles = _a.roles, userRoles = _a.userRoles;
    var permissionsRepo = new permission_container_1.PermissionContainer();
    var rolesRepo = new roles_container_1.RolesContainer();
    var userRolesRepo = new user_roles_container_1.UserRolesContainer();
    permissionsRepo.setPermissions(permissions);
    rolesRepo.setRoles(roles);
    userRolesRepo.setUserRoles(userRoles);
};
exports.setUser = function (userData) {
    var userRolesRepo = new user_roles_container_1.UserRolesContainer();
    userRolesRepo.setUser(userData);
};
//# sourceMappingURL=engine.js.map